/**
 * Case Closed (case acceptance): the unscheduled-treatment follow-up queue
 * on the office's cadence, each case's acceptance steps with payment options
 * and patient-initiated lender links, the in-house plan calculator, and
 * acceptance dollars. API `/v1/case-closed`. Velora never applies for credit
 * on a patient's behalf and nothing here sends a message or posts money.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'case-closed',
    title: 'Case Closed',
    version: '0.1.0',
    owner: 'WP2-TX',
    entitlementKey: null,
    permissions: [
      'txplan.view',
      'txplan.edit',
      'txplan.followup',
      'txplan.acceptance_report',
      'money.view',
    ],
    routes: [
      {
        id: 'queue',
        path: '/case-closed',
        title: 'Case Closed',
        officeScope: 'location-or-all',
        permission: 'txplan.view',
        readsPhi: true,
      },
      {
        id: 'analytics',
        path: '/case-closed/analytics',
        title: 'Acceptance dollars',
        officeScope: 'location-or-all',
        permission: 'txplan.acceptance_report',
        readsPhi: false,
      },
      {
        id: 'settings',
        path: '/case-closed/settings',
        title: 'Financing settings',
        officeScope: 'location',
        permission: 'txplan.edit',
        readsPhi: false,
      },
    ],
    nav: [
      {
        label: 'Case Closed',
        group: 'clinical',
        routeId: 'queue',
        icon: 'badge-percent',
        order: 33,
        permission: 'txplan.view',
      },
    ],
    commands: [
      {
        id: 'case-closed.queue',
        title: 'Case Closed: unscheduled treatment follow-up',
        keywords: [
          'case acceptance',
          'unscheduled treatment',
          'follow up',
          'financing',
          'carecredit',
          'sunbit',
          'cherry',
        ],
        routeId: 'queue',
        permission: 'txplan.view',
      },
      {
        id: 'case-closed.analytics',
        title: 'Case Closed: acceptance dollars',
        keywords: ['accepted', 'scheduled', 'completed', 'case acceptance dollars'],
        routeId: 'analytics',
        permission: 'txplan.acceptance_report',
      },
      {
        id: 'case-closed.settings',
        title: 'Case Closed: financing settings',
        keywords: ['payment plan', 'in-house plan', '0%', 'lender link', 'cadence'],
        routeId: 'settings',
        permission: 'txplan.edit',
      },
    ],
    sseEntityKeys: ['tx_case'],
    phiReadPoints: ['case_closed.queue', 'case_closed.case'],
  }),
  pages: {
    queue: () => import('./QueuePage.js'),
    analytics: () => import('./AnalyticsPage.js'),
    settings: () => import('./SettingsPage.js'),
  },
});
